import { render, staticRenderFns } from "./editApp.vue?vue&type=template&id=3847f962"
import script from "./editApp.vue?vue&type=script&lang=js"
export * from "./editApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports